<template>
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card mb-3">
          <div class="card-body">
            <h4 class="card-title">Screen Attachments</h4>
            <ul class="list-data no-links shadow-none" v-if="this.stateAttachments.length">
              <li v-for="file in this.stateAttachments" :key="file.id">
                <div class="row">
                  <div class="col-md-4 text-break">
                    {{ file.name }}
                  </div>
                  <div class="col-md-2">
                    <span class="text-muted">{{ formatFileSize(file.bytes) }}</span>
                  </div>
                  <div class="col-md-4">
                    {{ file.created_at }}
                  </div>
                  <div class="col-auto text-end ms-auto">
                    <a v-if="file.extension === 'pdf'" class="btn btn-sm text-info shadow-none border-0" @click.prevent="downloadFile(file.hash)" target="_blank">
                      <i class="far fa-cloud-download"></i>
                    </a>
                    <c-button v-else class="btn btn-sm text-info shadow-none border-0" style="background: none" @click="downloadFile(file.hash)">
                      <i class="far fa-cloud-download"></i>
                    </c-button>
                    <c-button v-if="$isA('admin')" class="btn btn-sm text-danger shadow-none border-0" style="background: none" @click="deleteFile(file.id)">
                      <i class="far fa-trash-alt"></i>
                    </c-button>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else class="text-muted">
              No attachments for this screen yet.
            </div>
          </div>
        </div>

        <div class="card" v-if="$isA('admin')">
          <div class="card-header">
            <h4 class="mb-0">Attachment Upload</h4>
          </div>

          <div class="card-body">
            <p>Upload attachment here for user to access necessary files related to this screen.</p>
            <file-uploader @file-selected="addFiles" ref="fileUploader" :uploading="uploading" @upload-files="uploadFiles" :error="error" :message="message"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stateMapper, helperComputed } from '@/vuex/modules/screens'
import { get } from 'vuex-pathify'
import { http } from '@/utils'
import FileUploader from '@/components/FileUploader.vue'
import { toast } from '@chameleon/chameleon-vue'
import { downloadBlob } from '@/utils/functions/download-blob'

export default {
  mixins: [
    stateMapper
  ],
  components: {
    FileUploader,
  },

  data () {
    return {
      selectedFiles: {},
      files: [],
      uploading: false,
      uploadProgress: 0,
      loadingFiles: false,
      message: '',
      error: ''
    }
  },

  async created () {
    await http.get(`screens/${this.screen.id}/attachments`)
  },

  computed: {
    ...helperComputed,
    ...get('screens', ['screen']),
  },

  methods: {
    addFiles (files) {
      this.selectedFiles = files
    },

    async uploadFiles () {
      if (!this.selectedFiles || !this.selectedFiles.length) return
      this.uploading = true
      this.uploadProgress = 0
      this.message = ''
      this.error = ''

      const formData = new FormData()
      Array.from(this.selectedFiles).forEach(file => {
        formData.append('files[]', file)
      })

      try {
        const response = await http.post(`screens/${this.screen.id}/attachments`, formData)

        this.message = response.data.message

        const map = new Map()
        const files = this.stateAttachments.concat(response.data.data)
        files.forEach(file => {
          map.set(file.id, file)
        })

        this.stateAttachments = Array.from(map.values())
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.error = error.response.data.message
        } else {
          this.error = 'Upload failed'
        }
      } finally {
        this.uploading = false
        this.selectedFiles = []
      }
    },

    async deleteFile (fileId) {
      try {
        await http.delete(`/attachments/${fileId}`)
        this.message = 'File deleted successfully'
        this.stateAttachments = this.stateAttachments.filter(file => file.id !== fileId)
      } catch (error) {
        toast('Failed to delete file', 'danger')
      }
    },

    async downloadFile (fileHash) {
      try {
        downloadBlob(await http.get(`attachments/${fileHash}/download`, { responseType: 'blob' }))
      } catch (error) {
        toast('Failed to download file', 'danger')
      }
    },

    formatFileSize (size) {
      if (size < 1024) return `${size} B`
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
      return `${(size / (1024 * 1024)).toFixed(2)} MB`
    },
  }
}
</script>
